// src/components/UserMenu.jsx  —  ohapotato v2026.10.36
import React, { useState, useRef, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export default function UserMenu({ user, onViewProfile }) {
  const { logout } = useAuth0();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const avatarSrc = user.picture;
  const initial   = (user.name || user.email || '?')[0].toUpperCase();

  return (
    <div ref={ref} style={s.wrap}>
      <button onClick={() => setOpen(o => !o)} style={s.avatarBtn} aria-label="User menu">
        {avatarSrc
          ? <img src={avatarSrc} alt={user.name} style={s.avatarImg} />
          : <span style={s.avatarInitial}>{initial}</span>
        }
      </button>

      {open && (
        <div style={s.dropdown}>
          <div style={s.userInfo}>
            <p style={s.userName}>{user.name || 'User'}</p>
            <p style={s.userEmail}>{user.email}</p>
          </div>
          <div style={s.divider} />
          <button style={s.item} onClick={() => { onViewProfile('profile'); setOpen(false); }}>
            <span style={s.itemIcon}>👤</span> Profile &amp; Settings
          </button>
          <button style={s.item} onClick={() => { onViewProfile('saved'); setOpen(false); }}>
            <span style={s.itemIcon}>🔖</span> Saved Recipes
          </button>
          <div style={s.divider} />
          <button style={{ ...s.item, ...s.logoutItem }}
            onClick={() => { logout({ logoutParams: { returnTo: window.location.origin } }); setOpen(false); }}>
            <span style={s.itemIcon}>↩</span> Sign out
          </button>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap: { position:'relative', marginLeft:'6px' },
  avatarBtn: {
    position:'relative',
    width:'34px', height:'34px', borderRadius:'50%',
    border:'2px solid var(--border-base)', background:'var(--bg-pill)',
    cursor:'pointer', overflow:'hidden',
    display:'flex', alignItems:'center', justifyContent:'center',
    transition:'border-color var(--transition)', padding:0,
  },
  avatarImg: { width:'100%', height:'100%', objectFit:'cover' },
  avatarInitial: {
    fontSize:'14px', fontWeight:'700',
    color:'var(--text-primary)', fontFamily:'var(--font-body)',
  },
  dropdown: {
    position:'absolute', top:'calc(100% + 8px)', right:0,
    minWidth:'210px',
    background:'var(--bg-card)',
    border:'1px solid var(--border-base)',
    borderRadius:'var(--radius-lg)',
    boxShadow:'var(--shadow-lg)',
    backdropFilter:'blur(16px)',
    zIndex:200,
    animation:'fadeUp 0.14s ease',
    overflow:'hidden',
  },
  userInfo: { padding:'13px 16px 11px' },
  userName: {
    fontSize:'13.5px', fontWeight:'600', fontFamily:'var(--font-body)',
    color:'var(--text-primary)', marginBottom:'3px',
    transition:'color 0.3s ease',
  },
  userEmail: {
    fontSize:'11.5px', color:'var(--text-muted)',
    overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap',
  },
  divider: { height:'1px', background:'var(--border-base)' },
  item: {
    display:'flex', alignItems:'center', gap:'9px',
    width:'100%', padding:'10px 16px',
    border:'none', background:'none', textAlign:'left',
    cursor:'pointer', fontFamily:'var(--font-body)',
    fontSize:'13px', fontWeight:'500',
    color:'var(--text-secondary)',
    transition:'background var(--transition)',
  },
  itemIcon: { fontSize:'14px', width:'16px', flexShrink:0 },
  _premiumDotRemoved: {
    position:'absolute', bottom:'-2px', right:'-2px',
    width:'14px', height:'14px', borderRadius:'50%',
    background:'var(--accent-gold)', color:'#fff',
    fontSize:'7px', display:'flex', alignItems:'center', justifyContent:'center',
    border:'1.5px solid var(--bg-surface)',
    fontWeight:'900',
  },
  logoutItem: { color:'var(--accent-orange)' },
};
